<template>
    <div class="form-layout">

        <div class="form-rows">
            <div class="fields input half" :class="{'has-error': errors.has('email') }">
                <label for="email">{{ locale.text_email_address_label }}</label>
                <input type="email" @keyup.enter="handle" v-validate="{ rules: { required: true } }" name="email" id="email" :placeholder="locale.text_email_address_label" v-model="email"/>
                <p class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</p>
            </div>

            <div class="fields input half right">
                <label>&nbsp;</label>
                <input type="button" @click="handle" class="cta-button blue" :value="locale.button_request_password" />
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                email: (this.$route.query.hasOwnProperty('email') ? this.$route.query.email : ""),
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.account.register;
            }
        },
        methods: {
            handle: function () {
                /**
                 * Obviously don't want to continue if there are errors.
                 */
                this.$validator.validateAll();
                if(this.errors.errors.length) {
                    $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                    return false;
                }

                /**
                 * Submitting! :)
                 */
                axios.post('camp-booking/users/send-password-reset-email', {
                    "email": this.email,
                    "password_reset_url": this.$root.config.base_domain + '/#/forgotten-password/reset'
                }).then(response => {
                    if(response.data.status == 'success')
                        this.$root.alert(this.locale.text_alert_request_password_email_sent.replace(':email', this.email), 'success');
                }).catch(error => {
                    this.$root.alert(error.response.data.data.message || this.locale.text_alert_request_password_error);
                    $("html, body").animate({ scrollTop: $(".title-bar").offset().top }, "slow");
                });

            }
        },
    }
</script>



// WEBPACK FOOTER //
// password.vue?b4145fb6